import { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useParams } from "react-router-dom";
import { SupportTicketView } from "./views/support-ticket-view";

export const Support = memo(function Support() {
  const { supportTicketId: supportTicketIdString } = useParams<{
    supportTicketId: string;
  }>();

  if (!supportTicketIdString) {
    return <div>Select a support ticket</div>;
  }

  const supportTicketId = SupportTicketId.make(supportTicketIdString);

  return (
    <Flex height="full" w="full">
      <SupportTicketView supportTicketId={supportTicketId} />
    </Flex>
  );
});
